import { RootState, StoreType } from '@redux/store';
import { Dispatch, UnknownAction } from '@reduxjs/toolkit';

const filteredKeys: (keyof RootState)[] = ['situation', 'sseApi', 'utm'] as const;

export const filterState = (state: RootState) =>
  Object.fromEntries(Object.entries(state).filter(([key]) => !filteredKeys.includes(key as keyof RootState)));

// Only intercept SEND_INIT_STATE, which is the init sync event
// and remove any unwanted attribut
export const interceptInitStateMiddleware = () => {
  return ({ getState }: StoreType) =>
    (next: Dispatch<UnknownAction>) =>
    (action: UnknownAction) => {
      if (action.type === '&_SEND_INIT_STATE') {
        const originalState = getState();
        const filteredState = filterState(originalState);
        action.payload = filteredState;
      }
      return next(action);
    };
};
